import React from 'react'

import Footer from '../tinycomp/Footer'
import DownloadButton from '../tinycomp/DownloadButton'

/* Pic import start */

import forms from '../../media/accordion1/graphic/forms.svg'
import example from '../../media/accordion1/graphic/example.webp'
import elements from '../../media/accordion1/graphic/elements.svg'
import navLegend from '../../media/accordion1/graphic/nav-legend.webp'
import navMap from '../../media/accordion1/graphic/nav-map.webp'

import elementsDownload from '../../media/accordion1/graphic/svg-elements.txt'

/* Pic import end */


function Graphic() {
  return (
    <>
      <section className='graphic-description'>
        <h1>Графика</h1>
        <p>Придерживаться фирменной графики крайне важно при разработке интерфейсов продукта и&nbsp;других носителей фирменного стиля для узнаваемости бренда.</p>
      </section>

      <section className='graphic-forms'>
        <h2>Формы</h2>
        <p>Фирменный стиль основан на&nbsp;использовании простых геометрических форм: квадратов, прямоугольников и&nbsp;прямоугольных трапеций. Формы не&nbsp;имеют скругления, могут быть использованы как с&nbsp;заливкой, так и&nbsp;в&nbsp;линеарном виде.</p>
        <p>Квадраты и&nbsp;прямоугольники задают четкий ритм всем дизайн-макетам. Прямые силуэты в&nbsp;духе конструктивизма указывают на&nbsp;продуманность концепции комплекса как единого целого, взаимосвязи всех частей внутри него. В&nbsp;то&nbsp;же время трапециевидные фигуры вносят некоторую динамику, игру перспективы в&nbsp;строгие композиции. Это отражает идею развития и&nbsp;движения вперед при сохранении общей устойчивости проекта.</p>
        <img src={forms}  alt='Формы' />
        <p>Эти формы могут быть использованы как отдельные графические элементы и&nbsp;как контейнеры для текста и&nbsp;фотографий (в&nbsp;этом случае соблюдаются правила отступов).</p>
        <img src={example}  alt='Пример использования' />
      </section>

      <section className='graphic-element'>
        <h2>Графические элементы</h2>
        <p>В&nbsp;фирменном стиле используются 5&nbsp;графических элементов. Они придают динамики и&nbsp;современности интерфейсу и&nbsp;другим носителям. Могут быть использованы отдельно или в&nbsp;сочетании с&nbsp;текстом, но&nbsp;не&nbsp;могут его перекрывать или быть контейнером для него. При этом графические элементы могут накладываться на&nbsp;фотографии.</p>
        <img src={elements}  alt='Различные графические элементы' />
        <DownloadButton picture={elementsDownload} />
      </section>

      <section className='graphic-nav'>
        <h2>Навигационная графика</h2>
        <p>Удобство передвижения&nbsp;&mdash; одна из&nbsp;наших ключевых задач. Продуманный дизайн навигационных планов помогает посетителям быстро сориентироваться в&nbsp;комплексе Апраксина двора. Навигационная графика используется и&nbsp;на&nbsp;печатных стендах, и&nbsp;в&nbsp;виде интерактивной карты на&nbsp;сайте и&nbsp;в&nbsp;мобильном приложении.</p>
        <p>Графические планы выполняются в&nbsp;упрощенно-схематичном стиле, с&nbsp;использованием условных цветовых и&nbsp;символьных обозначений для разных зон комплекса.</p>
        <p>Для создания планов используется 4&nbsp;вида линий разной толщины и&nbsp;цвета. Важно соблюдать назначение каждой из&nbsp;них.</p>
        <p>В&nbsp;картах используется набор фирменных иконок размером 16&times;16px. Иконки помещаются в&nbsp;квадратный контейнер 20&times;20px. Для удобства мы&nbsp;разделили их&nbsp;на&nbsp;4&nbsp;категории.</p>
        <img src={navLegend}  alt='Используемые обозначения на карте' />

        <div className='graphic-nav__container'>
          <img src={navMap}  alt='Пример карты' />
          <div className='graphic-nav__container-text'>
            <p>При создании планов соблюдайте достоверность, в&nbsp;частности реальные пропорции комплекса. Избегайте перегруженность деталями, но&nbsp;при этом сохраняйте все важные элементы и&nbsp;навигационные метки. Используйте максимально интуитивные пиктограммы в&nbsp;каждом случае, чтобы пользователь мог быстрее понять, что она обозначает.</p>
            <p>При этом у&nbsp;пользователя должна быть возможность получить больше информации, поэтому в&nbsp;интерфейсах в&nbsp;интерактивной карте используются подсказки. Кликнув по&nbsp;элементу, пользователь получает пояснение о&nbsp;нем.</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}

export default Graphic